var render, staticRenderFns
import script from "./nav-org-list-mixin.vue?vue&type=script&lang=js"
export * from "./nav-org-list-mixin.vue?vue&type=script&lang=js"
import style0 from "./nav-org-list-mixin.vue?vue&type=style&index=0&id=48d4e21f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4e21f",
  null
  
)

export default component.exports